var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCurveArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 62,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M61.5.844c-44.143-3-52.03 14.336-54.228 33.75m0 0L18 27M7.272 34.594 1.268 23.303",
  stroke: "#00BAC6"
})));
export { SvgCurveArrow as ReactComponent };
export default __webpack_public_path__ + "4d1eeb45825d47b16d589991f7f827fb.svg";